import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { FormsService } from 'src/app/services/forms.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from './login.service';
import { ResponseMessageStatus, ResponseStatus } from 'src/app/shared/enums';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  // validateForm!: FormGroup;
  //#region properties
  passwordVisible = false;
  //#endregion

  //#region function
  login() {
    this._cS.markFormGroupTouched(this._fS.loginForm);
    if (this._fS.loginForm.valid) {
      var formValue = this._fS.loginForm.value;
      var body = {
        "userName": formValue.email,
        "password": formValue.password
      }
      this._lS.loginService(body).subscribe(res => {
        if (res.responseStatus == ResponseStatus.Success) {
          this._cS.setLocalStorageItem('BrearToken', res.result.access_token)
          this._cS.setLocalStorageItem('userInfo', JSON.stringify(res.result.userdetails))
          this._router.navigate([`/bade-loft/dashboard`])
        } else if (res.responseStatus == ResponseStatus.NotFound) {
          this._cS.displayMessage(ResponseMessageStatus.error, 'Invalid credentials');
        }
      })
    }
  }

  checkAlreadyLoggedIn() {
    var JWTToken = this._cS.getLocalStorageItem('BrearToken')
    if (JWTToken != null) {
      this._router.navigate([`/bade-loft/dashboard`])
    }
  }
  //#endregion

  constructor(public _fS: FormsService,
    public _cS: CommonService,
    private _router: Router,
    private fb: FormBuilder,
    private _lS: LoginService
  ) {
    _fS.loginForm_fb();
  }

  ngOnInit(): void {
    document.title = 'Login - Badeloft';
    this.checkAlreadyLoggedIn();
  }


}
